import { render, staticRenderFns } from "./LazyLoadImgComment.vue?vue&type=template&id=6aeac336&scoped=true&"
import script from "./LazyLoadImgComment.vue?vue&type=script&lang=js&"
export * from "./LazyLoadImgComment.vue?vue&type=script&lang=js&"
import style0 from "./LazyLoadImgComment.vue?vue&type=style&index=0&id=6aeac336&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aeac336",
  null
  
)

export default component.exports